<form [formGroup]="settingsForm" class="form">
  <div class="form__horizontal-fields">
    <div class="form__field">
      <div class="form__field-inner-wrapper">
        <osp-form-field>
          <osp-label>{{ geoLabel }}</osp-label>
          <osp-dropdown
            [formControlName]="controlNames.SETTINGS_GLOBAL_GEOFENCE"
            [options]="globalGeofences()"
            optionValue="globalGeofenceId"
            optionLabel="globalGeofenceName"
          />
          <osp-error [messages]="{ required: 'shared.validation.requiredField' | translate }" />
        </osp-form-field>
      </div>
    </div>
    <div class="form__field">
      <div class="form__field-inner-wrapper">
        <osp-form-field>
          <osp-label [tooltip]="geoTriggerExplanation">{{ geoTriggerLabel }}</osp-label>
          <osp-dropdown [formControlName]="controlNames.SETTINGS_GEOFENCE_TRIGGER" [options]="triggerOptions" />
          <osp-error [messages]="{ required: 'shared.validation.requiredField' | translate }"></osp-error>
        </osp-form-field>
      </div>
    </div>
  </div>
  <div class="geofence-map-wrapper">
    <osp-map
      class="map-geofence"
      [latitude]="initialCenter()?.lat"
      [longitude]="initialCenter()?.lng"
      (mapInitialized)="mapReady($event)"
    />
  </div>
</form>
